import cx from 'classnames'
import { Fragment, useState } from 'react'

import { useGetGifsQuery } from 'store/api/yay/misc'

import ImageLoader from '../ImageLoader'

const ChatRoomModalGif = ({
  onSendMessage,
  onTogglePopup,
}: {
  onSendMessage: Function
  onTogglePopup?: Function
}) => {
  const gifs = useGetGifsQuery()

  const [__selectedIndex, __selectedIndexSet] = useState(0)

  return (
    <Fragment>
      <div className="GifCats__wrapper">
        <ul className="GifCats">
          {(gifs?.data?.gif_categories ?? []).map((_, i) => (
            <li key={i} className="GifCats__item">
              <a
                onClick={() => {
                  __selectedIndexSet(i)
                }}
                className={cx('GifCats__item__a', {
                  'GifCats__item__a--active': i == __selectedIndex,
                  'GifCats__item__a--gif': true,
                  [`GifCats__item__a--${i}`]: true,
                })}
              />
            </li>
          ))}
        </ul>
      </div>

      <div className="Gifs__wrapper">
        <ul className="Gifs">
          {(gifs?.data?.gif_categories?.[__selectedIndex]?.gifs ?? []).map(
            (x) => (
              <li
                className="Gifs__item"
                key={x.id}
                style={{
                  flex: `1 0 ${Math.floor(
                    ((x.width || 100) / (x.height || 100)) * 100
                  )}px`,
                }}
              >
                <a
                  onClick={() => {
                    onSendMessage({
                      messageType: 'gif',
                      gif_image_id: x?.id,
                      gif: x, // This is for `_tempMessage`.
                    }).then((res: any) => {
                      if (res?.['data']?.result == 'success') {
                        onTogglePopup?.()
                      }
                    })
                  }}
                >
                  <ImageLoader url={x.url} />
                </a>
              </li>
            )
          )}
        </ul>
      </div>
    </Fragment>
  )
}

export default ChatRoomModalGif
